export default {
  methods: {
    getCatchFilterResource() {
      const resource = this.url
        .split(`${this.$config.api_url}`)
        .filter(function (el) {
          return el != "";
        })[0]
        .split("?")[0];

      return resource ? resource : null;
    },
    async getFilterCacheResource(callback = () => {}) {
      try {
        const resource = this.getCatchFilterResource();
        const url =
          this.$config.api_url + this.$config.resources.filter_cache_resource;
        let prms = {
          resource: resource,
        };
        const response = await this.$httpService.get(url, prms);
        let data = response.data.data;
        return data.query_params;
      } catch (error) {
        this.$generateError(error);
      } finally {
        callback();
      }
    },
    async deleteFilterCacheResource() {
      try {
        const resource = this.getCatchFilterResource();
        const url =
          this.$config.api_url + this.$config.resources.filter_cache_resource;
        let params = {
          resource: resource,
        };
        const response = await this.$httpService.delete(url, params);
        this.$notify.success(response.data.message);
        this.paramsPage = {};
        this.fillTable();
        this.$refs.advanceFilter.deleteAll();
      } catch (error) {
        this.$generateError(error);
      }
    },
    getFilterItems(value, key) {
      if (
        (typeof value == "string" || typeof value == "number") &&
        value !== ""
      ) {
        this.paramsPage[key] = value;
      } else if (typeof value == "object" && value.length > 0) {
        this.paramsPage[key] = value;
      } else {
        delete this.paramsPage[key];
      }
      this.paramsPage["page"] = 1;
      this.page = 1;
      this.getItems();
    },
    getFilterDate(key, type, value_from, value_to) {
      if (value_to && value_from) {
        this.paramsPage[key] = [type, value_from, value_to];
      } else if (value_from) {
        this.paramsPage[key] = [type, value_from];
      } else {
        delete this.paramsPage[key];
      }
      this.paramsPage["page"] = 1;
      this.page = 1;
      this.getItems();
    },
  },
};
